import { css } from "@emotion/react";

import { NAVIGATOR_HEIGHT } from "@/constants/components";
import { useGuidebookQuestion } from "@/containers/GuidebookTipContainer/hooks/useGuidebookQuestion";

import { LargeButton, LARGEL_BUTTON_TYPE, VStack, useResponsive, customEvent } from "goi_common";

export function GuidebookFooter() {
  const { isBiggerThanMd, isBiggerThanXl } = useResponsive();

  const { handleQuestionRouting } = useGuidebookQuestion();

  const handleButtonClick = () => {
    customEvent({
      newGtm: {
        path: "guidebook",
        trigger_and_target: "post_qna_button-uv_guidebook_edit",
      },
    });

    handleQuestionRouting();
  };

  return (
    <>
      <div style={{ height: "60px" }} />
      <VStack position="fixed" css={bottomButtonCss({ isBiggerThanMd, isBiggerThanXl })}>
        <LargeButton
          buttonType={LARGEL_BUTTON_TYPE.PRIMARY}
          height={60}
          borderRadius={0}
          onClick={handleButtonClick}
        >
          <span className="subtitle2_b">내 질문 남기기</span>
        </LargeButton>
      </VStack>
    </>
  );
}
const bottomButtonCss = (props: { isBiggerThanMd: boolean; isBiggerThanXl: boolean }) =>
  css({
    position: "fixed",
    height: "60px",
    width: props.isBiggerThanXl ? "1200px" : "100%",
    bottom: props.isBiggerThanMd ? "0px" : `${NAVIGATOR_HEIGHT}px`,
  });
